import { render } from "./OrdersTracking.vue?vue&type=template&id=5980e77f&scoped=true"
import script from "./OrdersTracking.vue?vue&type=script&lang=js"
export * from "./OrdersTracking.vue?vue&type=script&lang=js"

import "./OrdersTracking.vue?vue&type=style&index=0&id=5980e77f&lang=scss&scoped=true"
import "./OrdersTracking.vue?vue&type=style&index=1&id=5980e77f&lang=scss"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5980e77f"]])

export default __exports__